import type { Metric, RowClassification } from "../shared/report";

export type StatusTone = RowClassification["status"];

export function metricTone(metric: Metric): StatusTone {
  if (metric.derived && metric.status) return metric.status;
  if (/good|correct|found|indexable|all images|with internal links|one h1/i.test(metric.label)) return "good";
  if (/potential|missing|few|multiple|needs improvement|redirect|short|long/i.test(metric.label)) return "warning";
  if (/serious|indexing issue|with issue|without|no h1|slow|error page|broken/i.test(metric.label)) return "critical";
  return metric.status ?? "neutral";
}

export function StatusIcon({ status, label }: { status: StatusTone; label?: string }) {
  return (
    <span className="status-icon" data-status={status} aria-hidden="true" title={label} />
  );
}
